import React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import {
  AccountCircleOutlined,
  AnnouncementOutlined,
  ExtensionOutlined,
  EmailOutlined,
} from '@mui/icons-material'
import { DescriptionOutlined } from '@mui/icons-material'

import { ThemeButton, useModalContext } from '../../../../ui'
import { MailingView } from '../../../mailing'

const GUILD_BUTTONS = (navigate, id, open, model) => ({
  APPLICATIONS: {
    id: 'link_applications',
    icon: <AnnouncementOutlined />,
    onClick: () => navigate(`/applications?gremio=${id}`),
  },
  IP: {
    id: 'linkIP',
    icon: <DescriptionOutlined />,
    onClick: () => navigate(`/ip?gremio_ip_id=${id}`),
  },
  JCA: {
    id: 'linkJCA',
    icon: <DescriptionOutlined />,
    onClick: () => navigate(`/jca?gremio_ip_id=${id}`),
  },
  ASSOCIATES: {
    id: 'link_adscribed',
    icon: <ExtensionOutlined />,
    onClick: () => navigate(`/eeii?gremio_id=${id}`),
  },
  ASSOCIATES_IP3: {
    id: 'linkAssociatesIP3',
    icon: <ExtensionOutlined />,
    onClick: () => navigate(`/eeii-ip?gremio_ip_id=${id}`),
  },
  COLLABORATORS: {
    id: 'link_collaborators',
    icon: <AccountCircleOutlined />,
    onClick: () => navigate(`/collaborators?gremio=${id}`),
  },
  MAILING_CONFIG: {
    id: 'mailing_config',
    icon: <EmailOutlined />,
    onClick: () => {
      open({
        Component: MailingView,
        data: { preferencias: model.preferencias || [] },
        type: 'responsive',
        closable: true,
        maxWidth: 'md',
      })
    },
  },
})

const userButtons = (user, company) => {
  const userRole = user.role
  const hasGestionSspp = user.permissions && user.permissions.gestion_sspp
  let buttons = []
  if (company.grabadora) {
    buttons = ['IP', 'JCA', 'ASSOCIATES_IP3', ...buttons]
  }
  if (company.captadora && userRole === 'call_center') {
    buttons = ['APPLICATIONS', ...buttons, 'ASSOCIATES']
  }
  if (userRole === 'call_center') {
    buttons = [...buttons, 'COLLABORATORS']
  }
  if (userRole === 'soporte_procesos' || userRole === 'e_commerce' || hasGestionSspp) {
    buttons = ['APPLICATIONS', 'ASSOCIATES', 'COLLABORATORS']
  }
  if (userRole === 'e_commerce') {
    buttons = [...buttons, 'MAILING_CONFIG']
  }
  return buttons
}

export const GuildActionButtons = ({ model }) => {
  const navigate = useNavigate()
  const { formatMessage } = useIntl()
  const user = useSelector((state) => state.global)
  const {
    actions: { open },
  } = useModalContext()

  const buttons = GUILD_BUTTONS(navigate, model.id, open, model)
  const buttonsIds = userButtons(user, model)

  return (
    <Box mb={1} display="flex" flexWrap="wrap">
      {buttonsIds.map((buttonId, i) => {
        const button = buttons[buttonId]
        return (
          <ThemeButton
            key={button.id}
            style={{ marginRight: i !== buttonsIds.length - 1 ? '1em' : 0, marginBottom: '1em' }}
            size="small"
            color="primary"
            onClick={() => button.onClick()}
            startIcon={button.icon}
          >
            {formatMessage({ id: `pages.guilds.headerButtons.${button.id}.title` })}
          </ThemeButton>
        )
      })}
    </Box>
  )
}

export default GuildActionButtons
